import { toRefs as P, computed as _, unref as x, resolveComponent as s, openBlock as a, createElementBlock as B, Fragment as b, renderSlot as l, normalizeProps as u, guardReactiveProps as c, createTextVNode as C, createBlock as M, Teleport as v, createVNode as d, withCtx as f } from "vue";
/* empty css                    */
import R from "./design-system.es128.js";
import h from "./design-system.es69.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
import y from "./design-system.es37.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import { useMenuProvider as N } from "./design-system.es293.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
const $ = {
  name: "DsPopoverNext",
  components: {
    MenuContainer: h,
    Box: y
  },
  inheritAttrs: !1,
  props: {
    /**
     * Controls the open state of the popover.  This makes the popover controlled and will not work with uncontrolled options.
     */
    isOpen: {
      type: Boolean,
      default: null
    },
    /**
     * Position of the popover, top bottom left right top-start top-end right-start right-end bottom-start bottom-end left-start left-end.
     */
    position: {
      type: String,
      default: "bottom",
      options: ["top", "right", "bottom", "left", "top-start", "top-end", "right-start", "right-end", "bottom-start", "bottom-end", "left-start", "left-end"]
    },
    triggerRef: {
      type: Object,
      default: null
    }
  },
  emits: ["close"],
  setup(t, { emit: o, attrs: n }) {
    const { triggerRef: r, isOpen: i, position: m } = P(t), { triggerProps: e, menuProps: p } = N({
      trigger: r,
      isOpen: i,
      position: m,
      arrow: !0,
      onRequestClose: () => {
        o("close");
      }
    }), g = _(() => ({
      ...n,
      ...x(p)
    }));
    return {
      triggerProps: e,
      menuProps: g
    };
  }
};
function k(t, o, n, r, i, m) {
  const e = s("Box"), p = s("MenuContainer");
  return a(), B(b, null, [
    l(t.$slots, "default", u(c(r.triggerProps))),
    o[0] || (o[0] = C()),
    (a(), M(v, { to: "body" }, [
      d(p, u(c(r.menuProps)), {
        default: f(() => [
          d(e, { padding: "spacing-200" }, {
            default: f(() => [
              l(t.$slots, "content")
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 16)
    ]))
  ], 64);
}
const at = /* @__PURE__ */ R($, [["render", k]]);
export {
  at as default
};
//# sourceMappingURL=design-system.es313.js.map
